import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from '../../../../../core';
import { isCampanhaLeadVisualizacaoModoAmbos, isCampanhaLeadVisualizacaoModoQualificacoes, isCampanhaLeadVisualizacaoModoOrigens } from '../visualizacao-modo';
import { CampanhaLeadFilter } from './campanha-lead-filter';

@Component({
    selector: 'sgt-campanha-lead-filter',
    templateUrl: './campanha-lead-filter.component.html',
    styleUrls: ['./campanha-lead-filter.component.less']
})
export class CampanhaLeadFilterComponent implements OnInit {
    idUsuarioLogado: number;

    @Input() idCampanha: number;
    @Input() filter: CampanhaLeadFilter;
    @Output() filterChange = new EventEmitter<any>();

    // Mulstiselects
    isFirstChangeUsuariosResponsaveis = true;
    isFirstChangeClassificacoesMultiselect = true;

    constructor(private authService: AuthService) { }

    ngOnInit(): void {
        this.idUsuarioLogado = this.authService.getIdUsuario();
        this.setIDCampanhaByModoVisualizacao();
    }

    /** Seta o ID da campanha informada no filtro das campanhas dos leads conforme o modo de visualização das campanhas */
    private setIDCampanhaByModoVisualizacao() {
        this.filter.idsCampanhasOrigens = [];
        this.filter.idsCampanhasQualificacoes = [];
        this.filter.idsCampanhasOrigensQualificacoes = [];
        if (isCampanhaLeadVisualizacaoModoOrigens(this.filter.visualizacaoModo)) { // Campanhas de Origens
            this.filter.idsCampanhasOrigens = [this.idCampanha];
        } else if (isCampanhaLeadVisualizacaoModoQualificacoes(this.filter.visualizacaoModo)) { // Campanhas de Aquisições
            this.filter.idsCampanhasQualificacoes = [this.idCampanha];
        } else if (isCampanhaLeadVisualizacaoModoAmbos(this.filter.visualizacaoModo)) { // Ambos
            this.filter.idsCampanhasOrigensQualificacoes = [this.idCampanha];
        }
    }

    /** Ao alterar o modo de visualização das campanhas, setamos a campanha no filtro correto das campanhas dos leads */
    onChangeModoVisualizacao(visualizacaoModo: number) {
        this.filter.visualizacaoModo = visualizacaoModo;
        this.setIDCampanhaByModoVisualizacao();
        this.filterChange.emit();
    }

    /** Ao alterar os usuários responsáveis */
    onChangeUsuariosResponsaveis() {
        if (this.isFirstChangeUsuariosResponsaveis) {
            this.isFirstChangeUsuariosResponsaveis = false;
            return;
        }

        this.filterChange.emit();
    }

    /** Ao alterar as classificações */
    onChangeClassificacoes() {
        if (this.isFirstChangeClassificacoesMultiselect) {
            this.isFirstChangeClassificacoesMultiselect = false;
            return;
        }
        this.filterChange.emit();
    }

    /** Ao alterar as temperaturas */
    onChangeTemperaturasLead() {
        this.filterChange.emit();
    }

    /** Limpa o filtro */
    clear() {
        this.filter.clear();
        this.setIDCampanhaByModoVisualizacao();

        setTimeout(() => this.filterChange.emit(), 0);
    }
}
